import {
    DASHBOARD_METHOD
} from '@app/const/AppSetting';
import axiosClient from './axios';

export const thongkedaohuunhadan = async () => {
    const v = await axiosClient.get('/Main/thongkedashboard01');
    return v.data.data;
};